vcui.define('support/common/searchModelNew.min', ['jquery', 'vcui'], function ($, core) {
    "use strict";

    var selectedBarTmpl = 
        '<div class="box">' +
            '<div class="prod-info">' +
                '{{# if (typeof tit != "undefined") { #}}' +
                '<p class="tit">제품을 선택해 주세요.</p>' +
                '{{# } #}}' +
                '{{# if (typeof product != "undefined") { #}}' +
                    '{{# if (isMyProduct == "Y") { #}}' +
                        '<div class="flag-wrap bg-type"><span class="flag black"><span class="blind">상품 분류</span>보유제품</span></div>' +
                    '{{# } #}}' +
                    '<ul class="product">' +
                        '{{# for (var i = 0; i < product.length; i++) { #}}' +
                            '{{# if (product[i].name) { #}}' +
                                '<li>{{product[i].name}}</li>' +  
                            '{{# } #}}' +
                        '{{# } #}}' +
                    '</ul>' +
                '{{# } #}}' +
            '</div>' +
            '{{# if (typeof reset != "undefined") { #}}' +
            '<div class="prod-btn">' +
                '{{# if (reset == "type") { #}}' +
                '<button type="button" class="btn size reset btn-reset">문의 유형 재선택</button>' +
                '{{# } #}}' +
                '{{# if (reset == "product") { #}}' +
                '<button type="button" class="btn size reset btn-reset">변경</button>' +
                '{{# } #}}' +
                '{{# if (reset == "noProduct") { #}}' +
                '<button type="button" class="btn size reset btn-reset">제품 선택</button>' +
                '{{# } #}}' +
            '</div>' +
            '{{# } else { #}}' +
            '<div class="prod-btn">' +
                '<button type="button" class="btn size reset btn-reset">변경</button>' +
            '</div>' +
            '{{# } #}}' +
        '</div>';

    var modelListTmpl = 
        '<div class="slide-conts">' +
            '{{# if (modelCode != "") { #}}' +
            '<a href="#" class="item" data-cst-flag="Y" data-category="{{category}}" data-sub-category="{{subCategory}}" data-model-code="{{modelCode}}" data-product-code="{{productCode}}" data-category-nm="{{categoryNm}}" data-sub-category-nm="{{subCategoryNm}}"{{#if typeof salesModelCode != "undefined"}} data-sales-model-code="{{salesModelCode}}"{{/if}}>' +
            '{{# } else { #}}' +
            '<a href="#" class="item no-model" data-cst-flag="Y" data-category="{{category}}" data-sub-category="{{subCategory}}" data-model-code="{{modelCode}}" data-product-code="{{productCode}}" data-category-nm="{{categoryNm}}" data-sub-category-nm="{{subCategoryNm}}">' +
            '{{# } #}}' +
                '<div class="info">' +
                    '{{# if (modelCode != "") { #}}' +
                        '<p class="name">{{#raw name}}</p>' +
                        '<p class="category"><span>{{categoryNm}} &gt; </span>{{subCategoryNm}}</p>' +
                    '{{# } else { #}}' +
                        '<p class="name">모델명을 모르겠어요.</p>' +
                        '<p class="category"><span>건너뛰기</span></p>' +
                    '{{# } #}}' +
                '</div>' +
            '</a>' +
        '</div>';

    var topicTmpl = 
        '{{#each (item, index) in topicList}}' +
        '<li>' +
            '<span class="rdo-wrap btn-type4">' +
                '{{# if (index == 0) { #}}' +
                '<input type="radio" name="sympCd" id="topic{{index}}" value="{{item.value}}" data-topic-name="{{item.name}}" data-error-msg="정확한 제품증상을 선택해 주세요." data-required="true" required>' +
                '{{# } else { #}}' +
                '<input type="radio" name="sympCd" id="topic{{index}}" value="{{item.value}}" data-topic-name="{{item.name}}">' +
                '{{# } #}}' +
                '<label for="topic{{index}}"><span>{{item.name}}</span></label>' +
            '</span>' +
        '</li>' + 
        '{{/each}}';

    var myModel = [];
    var isLogin = lgkorUI.isLogin;

    var SearchModelNew = core.ui('SearchModelNew', /** @lends vcui.ui.vcSearchModelNew# */{
        bindjQuery: 'searchModelNew',
        defaults: {
            stepClass: 'step-box',
            stepActiveClass: 'active',
            page: 1,
            total: 0,
            useCookie: false,
            onlyMyModel: false,
            reset: false,
            model: {
                category: '',
                categoryNm: '전체',
                subCategory: '',
                subCategoryNm: '전체',
                modelCode: '',
                productCode: '',
                pageCode: $('#pageCode').val(),
                serviceType: $('#serviceType').val(),
                salesModelCode: $('#salesModelCode').val()
            },
            summary: {
                tit: '서비스이용을 위해 제품을 선택해 주세요.'
            },
        },
        initialize: function initialize(el, options) {
            var self = this;
            
            if (self.supr(el, options) === false) {
                return;
            }
            
            var opts = $.extend(true, {}, self.options, {
                model: {
                    category: self.$el.find('#category').val(),
                    categoryNm: self.$el.find('#categoryNm').val(),
                    subCategory: self.$el.find('#subCategory').val(),
                    subCategoryNm: self.$el.find('#subCategoryNm').val(),
                    modelCode: self.$el.find('#modelCode').val(),
                    productCode: self.$el.find('#productCode').val(),
                    accessType1: "",
                    accessType2: self.$el.find('#accessType2').val()
                }
            });

            self.$cont = $('.contents');
            self.$tabWrap = self.$cont.find('#tabs-prod');

            self.$stepArea = self.$cont.find('#stepArea');
            self.$stepInput = self.$stepArea.find('#stepInput');

            self.$topicBox = self.$stepInput.find('#topicBox');
            self.$topicListWrap = self.$topicBox.find('#topicList');
            self.$topicList = self.$topicListWrap.find('.rdo-list');

            self.$saleInfoBox = self.$stepArea.find('#saleInfo'); //설치형태
            self.$fanBox = self.$stepInput.find("#fanBox");
            // self.$rentalYnBox = self.$stepInput.find("#rentalYnBox");	//렌탈여부
            self.$bdTypeBox = self.$stepInput.find("#bdTypeBox");	//건물유형
            self.$tvPositionBox = self.$stepInput.find('#tvPositionBox');
            self.$installTypeBox = self.$stepInput.find('#installTypeBox');
            self.$addFanBox = self.$stepInput.find('#addFanBox');
            self.$salesDtWrap = self.$saleInfoBox.find('#salesDt'); // 상담 예약

            // BTOCSITE-3312 add :: 출장예약페이지인지 확인
            self.isEngineerReservation = $('#pageCode').val() == 'B00054'; //출장예약

            // BTOCSITE-11168 제품문제 해결 - 모델명 선택 절차 제외 요청
            self.isSolutions = self.$el.hasClass('solutions');
            // BTOCSITE-18597 동영상가이드 메뉴 수정 요청
            self.isVideoGuide = self.$el.hasClass('video-guide');
            
            // 스텝 영역
            self.$stepBox = self.$el.find('.step-box');
            self.$stepInquiry = self.$el.find('#stepInquiryType');
            self.$stepModel = self.$el.find('#stepModel');
            
            // 선택 제품 플로팅바
            self.$selectedModelBar = self.$el.find('.goods-selected-wrap');
            
            // 보유제품
            self.$myModelWrap = self.$el.find('.my-product-wrap');
            self.$myModelSlider = self.$myModelWrap.find('.my-product-slider');

            // 검색 영역
            self.$prodSearchWrap = self.$el.find('.prod-search-wrap');
            self.$searchBox = self.$prodSearchWrap.find('.search-area');


            // 모델명/제조번호 //BTOCSITE-62364 모델번호, 제조번호 입력
            self.$modelSearchBox = self.$prodSearchWrap.find('#modelSearchBox');
            self.$modelSelectBox = self.$prodSearchWrap.find('#modelSelectBox');
            // 검색 영역 : 모델
            //self.$modelBox = self.$prodSearchWrap.find('#model-box');
            //self.$modelFilter = self.$modelBox.find('.form-wrap');
            self.$modelSearchInput = self.$modelSearchBox.find('input[id=search]');
            self.$modelSearchSerialNm = self.$modelSearchBox.find('input[id=sn]');
            self.$modelSearchButton = self.$modelSearchBox.find('.btn-search');
            self.$modelSearchError = self.$modelSearchBox.find('.search-error');
            //self.$modelSlider = self.$modelBox.find('.model-slider');
            //self.$modelNoData = self.$modelBox.find('.no-data');

            // 스스로해결
            self.$modelBox = self.$prodSearchWrap.find('#model-box');
            self.$modelInput = self.$modelBox.find('input[id=search]');
            self.$modelButton = self.$modelBox.find('.btn-search');
            self.$modelError = self.$modelBox.find('.search-error');

            // 팝업
            self.$modelPopup = $('#modelNamePopup');
            // 옵션
            self.subCategoryUrl = self.$prodSearchWrap.data('subCategoryUrl');
            self.resultUrl = self.$prodSearchWrap.data('resultUrl');
            self.typeFlag = self.$prodSearchWrap.data('typeFlag');
            self.page = opts.page;
            self.totalCount = opts.totalCount;
            self.hasModel = opts.model.subCategory ? true : false;
            self.model = $.extend(true, {}, opts.model);
            self.param = $.extend(true, {}, self.defaults.model, {
                keyword: ''
            });

            self._setMyModel();
            
            if (!opts.onlyMyModel) {
                lgkorUI.searchModelName();

                self._bindEvent();
                
                if (opts.reset) {
                    self.reset();
                } else {
                    if (lgkorUI.searchParamsToObject('mktModelCd')) {
                        self.options.useCookie = false;
                        self.model.modelCode = self.model.mktModelCd = lgkorUI.searchParamsToObject('mktModelCd');
                        self.hasModel = self.model.subCategory ? true : false;
                        
                        if (self.model.accessType2 == '001'){
                        	self.model.accessType = "001";  
                        	self.model.accessType2 = "000";
                        }else if (self.model.accessType2 == '005'){
                        	self.model.accessType = "005";  
                        	self.model.accessType2 = "000";
                        }

                        //self.$prodSearchWrap.hide();
                    }
                    
                    //subCategory 존재시 step2 로 이동 (서충원, 230622)
                    if (self.hasModel) {
                        self.complete();
                    }else{
                        //BTOCSITE-95465 출장서비스예약 Scene 내 제품정보 식별 로직 개선 (제조번호 추가)
                        self.setModelCodeAsParam(); //모델명, 제조번호 값 셋팅

                    }
                    /* if (self.hasModel) {
                        if (self.options.useCookie) {
                            if (self.hasModel) {
                                
                                
                                //alert 문구 삭제(서충원, 230614)
                                 lgkorUI.alert(
                                    self.model.categoryNm + ' &gt; ' +self.model.subCategoryNm + (self.model.modelCode ? '<br><span style="font-weight:700">"' +self.model.modelCode+ '"</span>' : '' ) +'<br>제품이 선택되어 있습니다.<br><br>다른 제품으로 변경하시려면<br>화면 상단 <span style="font-weight:700">"제품 재선택"</span> 버튼을 선택해 주세요.', {
                                    okBtnName: '닫기',
                                    ok: function() {
                                        self.complete();
                                    }
                                });
                            }
                        } else {
                            if (self.model.mktModelCd || !self.model.modelCode) {
                                
                                self.complete();
                            }
                        }
                    } */
                }
            }	

            // 모델명 입력 / 검색 Input Box 모델명 검색 글자수 제한
            self.$modelSearchInput.attr('maxlength','30');
            // BTOCSITE-20543 고객지원 메뉴 - 포커스 이동 위치 수정
            self.headerHeight = self.isMobile() ? $('.header-wrap').height() : 0;
        },
        _bindEvent: function _bindEvent() {
            var self = this;

            // 보유제픔 등록
            self.$selectedModelBar.on('click', '.btn-add-product', function(e) {
                e.preventDefault();
                var href = $(this).attr('href');
                lgkorUI.setAcecounter('www.lge.co.kr/acecount/modelselectProductRegClick.do', '/acecount/modelselectProductRegClickm.do');
                location.href = href + '?modelCode=' + self.model.salesModelCode;
            });

            // 제품 재선택
            self.$selectedModelBar.on('click', '.btn-reset', function() {
                lgkorUI.setAcecounter('www.lge.co.kr/acecount/modelselectReselectClick.do', '/acecount/modelselectReselectClickm.do');
                self.reset();
            });

            // 문의 유형 : 보유 제품 선택
            self.$stepInquiry.find('.btn-next').on('click', function() {
                //self.$selectedModelBar.show();
                if (self.hasModel) {
                    self.complete()
                } else {
                    self.$myModelWrap.show();
                    self.next(self.$stepModel);
                    self.focus(self.$selectedModelBar);
                    // self.$myModelSlider.vcCarousel('resize');
                }
            });

            // 문의 유형 선택
            self.$stepInquiry.find('.btn-type').on('click', function() {
                var data = $(this).data();

                data.categoryNm = data.categoryName;
                data.subCategoryNm = data.subCategoryName;
                data.modelCode = '';
                data.productCode = '';

                self.complete(data);
            });

            
            



            

            // 카테고리 > 검색어 입력
            self.$modelSearchInput.on('input', function() {
                //dup-event
                return;
                var $this = $(this),
                    value = $this.val().toUpperCase();

                // BTOCSITE-9665 고객지원 모델명 검색창 한글 입력 허용
                // var regex = /[^a-zA-Z0-9.\-]/g;
                var regex =/[^가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9.\-]/g;

                if (regex.test(value)) {
                    $this.val(value.replace(regex,""));
                    return;
                }

                value = $this.val().toUpperCase();
                    
                if (value.length > 1 || !value) {
                    self.param = $.extend(self.param, {
                        keyword: value,
                        page: 1
                    });

                    self.$modelSearchError.hide();
                } else {
                    self.$modelSearchError.show();
                }
            });

            // 카테고리 > 검색어 엔터
            self.$modelSearchInput.on('keyup', function(e) {
                //dup-event
                // return;
                // if (e.keyCode == 13) {
                //     e.preventDefault();
                //     self.$modelSearchButton.trigger('click');
                // }
                var searchVal = $(this).val().toUpperCase();
                var chkdata = self.$modelSearchBox.find('.keyword-list').find('li').find('[data-model-code="'+searchVal+'"]');
				var salesModelCode = $('#salesModelCode').val();
				if((e.keyCode === vcui.keyCode.BACKSPACE && salesModelCode != '') || (chkdata.length == 0 && salesModelCode != '')) {
                    
                    self.param = $.extend(self.param, {
                        category: '',
                        subCategory: '',
                        categoryNm: '',
                        subCategoryNm: '',
                        modelCode: '',
                        productCode: '',
                        salesModelCode:	''
                    });
				}
            });

            // 카테고리 > 검색어 버튼 클릭
            self.$modelSearchButton.on('click', function() {
                //dup-event
                return;
                var value = self.$modelSearchInput.val().toUpperCase();

                if (value.length > 1 || !value) {
                    self.param = $.extend(self.param, {
                        keyword: value,
                        page: 1
                    });

                    self._requestTopicData();
                    self.$modelSearchError.hide();
                } else {
                    self.$modelSearchError.show();
                }
            });

            // 모델명 선택
            self.$modelSearchBox.on('click', '.search-layer .autocomplete-box a', function(e) {
                e.preventDefault();
                
                var $this = $(this),
                    data = $this.data();

                /* BTOCSITE-3312 add :: 출장예약 페이지일때 모델명을 몰라요 클릭시 팝업 추가 */
                // if (!!data.modelCode == false && self.isEngineerReservation){
                //     //var alertMsg = '서비스 접수 확인 문자의 <strong class="point">[제품 / 설치 환경 사진등록]</strong> 으로 사진 업로드 하시면 정확하고 신속한 서비스가 가능 합니다.<br><br>모델명 입력을 건너뛰기 하시겠습니까?';
                //     //BTOCSITE-4410
                //     var alertMsg = '모델명을 입력하시면 신속 정확한 서비스가 가능 합니다.<br><br>접수 확인 문자 <strong class="point">[제품 / 설치 환경 사진등록]</strong> 에서도 모델명 사진 업로드 가능<br><br>모델명을 입력 하시겠습니까?';
                //     lgkorUI.confirm(alertMsg,{
                //         typeClass:'type2',
                //         title:'',
                //         okBtnName: '네',
                //         cancelBtnName: '아니요',
                //         ok: function() {
                //             //self.complete(data);
                //         },
                //         cancel: function() {
                //             self.complete(data);
                //         }
                //     });
                //     return;                   
                // }         
                /* //BTOCSITE-3312 add */

                self.param = $.extend(self.param, {
                    category: data.category,
                    subCategory: data.subCategory,
                    categoryNm: data.categoryNm,
                    subCategoryNm: data.subCategoryNm,
                    modelCode: data.modelCode,
                    productCode: data.productCode,
                    salesModelCode:	data.salesModelCode
                });
                
                $('#category').val(data.category);
                $('#categoryNm').val(data.categoryNm);
                $('#subCategory').val(data.subCategory);
                $('#subCategoryNm').val(data.subCategoryNm);
                $('#modelCode').val(data.modelCode);
                $('#productCode').val(data.productCode);
                $('#salesModelCode').val(data.salesModelCode);

                self.updateSummary({
                    product: [data.categoryNm, data.subCategoryNm, data.modelCode]
                });

                self.completeSummary(self.param);

                self.$modelSearchInput.val(data.modelCode);
                // BTOCSITE-62364 모델번호, 제조번호 입력
                //self.$tabWrap.addClass('dpn');
                // self.$selectedModelBar.show(); // 플로팅바 노출
                //self.$stepArea.show(); // 정보 입력창 노출
                //self.$prodSearchWrap.hide();
                //$('#tabs-prod').hide();
                //self.complete(self.param);
                //self._requestTopicData();
            });
            
            // 모델명 선택 - 카테고리 선택
            self.$modelSelectBox.find('#categorySelect').on('change', function(e, subValue) {
                var $this = $(this);

                if ($this.val() === "all") {
                    //$('#prdGrp02').hide();
                    return;
                }

                var param = {
                    categorySelect: $this.val()
                };
                var value = typeof subValue === 'string' ? subValue : '';

                $("#category").val(param.categorySelect);
                $("#categoryNm").val($this.find('option:selected').text());

                lgkorUI.showLoading();
                
                lgkorUI.requestAjaxData(self.subCategoryUrl, param, function(result) {
                    lgkorUI.hideLoading();
                    var $subCategory = self.$modelSelectBox.find('#subCategorySelect');
                    var data = result.data.optionData || result.data,
                        arr = data instanceof Array ? data : [],
                        html = '';

                    if (arr.length) {
                        html += '<option value="all" data-category-name="all" class="placeholder">제품명 선택</option>'
                        arr.forEach(function(item) {
                            html += vcui.template('<option value={{value}}>{{name}}</option>', item);
                        });
            
                        $subCategory
                            .html(html)
                            .val(value)
                            .prop('disabled', false);
                    }

                    $subCategory.vcSelectbox('update');
                    
                    self.$modelPopup.data('category', $this.val());
                    self.$modelPopup.data('subCategory', value);
                    
                    self.param = $.extend(self.param, {
                        category: $this.val(),
                        categoryNm: $this.find('option:selected').text(),
                        subCategory: value,
                        subCategoryNm: $subCategory.find('option[value="'+value+'"]').text(),
                        page: 1
                    });

                    if (typeof subValue !== 'string') {
                        self.updateSummary({
                            product: [$this.find('option:selected').text(), $subCategory.find('option[value="'+value+'"]').text()]
                        });
                    }
                    // $('#prdGrp02').find('.ui-selectbox-wrap').addClass('on'); // 서브 카테고리 자동 열림
                    // $('#prdGrp02').find('.ui-selectbox-list').show();

                    // self.completeSummary(self.param);

                    self.$modelSelectBox.find('#subCategorySelect').trigger('selectboxopen');  // 서브 카테고리 펼침
                });
            });

            // 모델명 선택 - 서브 카테고리 선택
            self.$modelSelectBox.find('#subCategorySelect').on('change', function() {

                var $this = $(this),
                    $category = self.$modelSelectBox.find('#categorySelect');
                    
                if ($this.val() === "all") {
                    return;
                }

                // if (self.$el.hasClass('service-engineer') && ($this.val() == 'CT50019259' || $this.val() == 'CT50019244') && $('#hiDownTimeFlag').val() == 'Y') {                    
                //     lgkorUI.alert('(자세한 내용은 공지사항을 확인하시기 바랍니다.)<br>점검시간 : '+ $('#hirunDownStartTime').val() +' ~ '+ $('#hirunDownEndTime').val(),{
                //         title: '시스템 점검 중으로, <br>\'시스템에어컨\', \'업소용 스탠드형\'<br>신청 및 조회가 불가합니다.'
                //     });
                //     return;
                // }

                self.$modelPopup.data('category', $category.val());
                self.$modelPopup.data('subCategory', $this.val());

                self.param = $.extend(self.param, {
                    category: $category.val(),
                    subCategory: $this.val(),
                    categoryNm: $category.find('option:selected').text(),
                    subCategoryNm: $this.find('option:selected').text()
                });

                $("#subCategory").val(self.param.subCategory);
                $("#subCategoryNm").val($this.find('option:selected').text());
                
                self.updateSummary({
                    product: [$category.find('option:selected').text(), $this.find('option:selected').text()]
                });

                //self.$selectedModelBar.show(); // 플로팅바 노출
                //self.$stepArea.show(); // 정보 입력창 노출
                //$('#tabs-prod').hide();
                self._requestSearchEngine();
                self._requestTopicData();

                //self.complete(self.param);                
                // self.completeSummary(self.param);
            });

            // prodCategorySelect 카테고리 선택
            self.$modelSearchBox.find('#prodCategorySelect').on('change', function(e, subValue) {
                var $this = $(this);

                if ($this.val() === "all") {
                    return;
                }

                var param = {
                    categorySelect: $this.val()
                };
                var value = typeof subValue === 'string' ? subValue : '';

                $("#category").val(param.categorySelect);
                $("#categoryNm").val($this.find('option:selected').text());

                lgkorUI.showLoading();
                lgkorUI.requestAjaxData(self.subCategoryUrl, param, function(result) {
                    lgkorUI.hideLoading();
                    var $subCategory = self.$modelSearchBox.find('#prodSubCategorySelect');
                    var data = result.data.optionData || result.data,
                        arr = data instanceof Array ? data : [],
                        html = '';

                    if (arr.length) {
                        html += '<option value="all" data-category-name="all" class="placeholder">제품명 선택</option>'
                        arr.forEach(function(item) {
                            html += vcui.template('<option value={{value}}>{{name}}</option>', item);
                        });

                        $subCategory
                            .html(html)
                            .val(value)
                            .prop('disabled', false);
                    }

                    $subCategory.vcSelectbox('update');
                    
                    self.$modelPopup.data('category', $this.val());
                    self.$modelPopup.data('subCategory', value);
                    
                    self.param = $.extend(self.param, {
                        category: $this.val(),
                        categoryNm: $this.find('option:selected').text(),
                        subCategory: value,
                        subCategoryNm: $subCategory.find('option[value="'+value+'"]').text(),
                        page: 1
                    });

                    if (typeof subValue !== 'string') {
                        self.updateSummary({
                            product: [$this.find('option:selected').text(), $subCategory.find('option[value="'+value+'"]').text()]
                        });
                    }
                    self.$modelSearchBox.find('#prodSubCategorySelect').trigger('selectboxopen');  // 서브 카테고리 펼침
                });
            });

            // prodSubCategorySelect 서브 카테고리 선택
            self.$modelSearchBox.find('#prodSubCategorySelect').on('change', function() {

                var $this = $(this),
                    $category = self.$modelSearchBox.find('#prodCategorySelect');
                    
                if ($this.val() === "all") {
                    return;
                }

                self.$modelPopup.data('category', $category.val());
                self.$modelPopup.data('subCategory', $this.val());

                self.param = $.extend(self.param, {
                    category: $category.val(),
                    subCategory: $this.val(),
                    categoryNm: $category.find('option:selected').text(),
                    subCategoryNm: $this.find('option:selected').text()
                });

                $("#subCategory").val(self.param.subCategory);
                $("#subCategoryNm").val($this.find('option:selected').text());
                
                self.updateSummary({
                    product: [$category.find('option:selected').text(), $this.find('option:selected').text()]
                });

                self._requestSearchEngine();
                self._requestTopicData();

            });

			//모델명/제조번호로 예약하기
			self.$modelSearchBox.find('.btn-prod-next').on('click', function(e) {
				self._requestTopicData();
			});	


            //BTOCSITE-91187 고객지원 > 서비스 예약 > 모델명, 제조번호 입력 시 OCR 제공
            self.$modelSearchBox.on('change', '#ocrImageFile', function(e) {
                var $this = $(this);
                self.reset();
                
                var url = '/support/analyzeImage.lgajax';
                var imageFile = document.querySelector("#ocrImageFile").files[0] || '';
                var formData = new FormData();

                formData.append('typeFlag', self.typeFlag);
                formData.append('pageCode', $('#pageCode').val());
                formData.append('serviceType', $('#serviceType').val());
                formData.append('imageFile', imageFile);

                if(imageFile != ''){
                    $this.val(''); //value값 삭제
                    lgkorUI.showLoading();
                    lgkorUI.requestAjaxFileData(url, formData, function(result) {

                        var data = result.data; 

                        if(data.status == '200'){
                            //detectYn : N 성공, Y 실패
                            if(data.detectYn == 'N'){
                                self.$modelSearchBox.find('[id="search"]').vcInputClearButton('updateVal', data.modelCode);
                                self.$modelSearchBox.find('[id="sn"]').val(data.serialNumber);
                                $('#serialNumber').val(data.serialNumber);
        
                                self.getSearchModeOCR(data.modelCode);
                                lgkorUI.pushDataLayer('이미지', '이미지 - 업로드', '업로드 완료'); // GA 태그 호출
                            }else{
                                $(window).trigger("toastshow", '사진 인식에 실패 하였습니다.');
                                lgkorUI.hideLoading();
                            }
                        }else{
                            lgkorUI.hideLoading();
                        }
                    }, 'POST');    
                }
            });

            $('.prod-model-box').on('click', '.btn-prod-open', function() {						
                self.reset();
            });	
            // 모델 리스트 슬라이더
            // $(window).on('resize', function() {
            //     //self._resetFlexibleBox();
            //     // BTOCSITE-20543 고객지원 메뉴 - 포커스 이동 위치 수정
            //     self.headerHeight = self.isMobile() ? $('.header-wrap').height() : 0;
            //     if(vcui.string.toFirstLower(self.$selectedModelBar.attr('ui-modules')) == 'sticky') {
            //         self.$selectedModelBar.vcSticky('setMarginTop', self.headerHeight);

            //         // BTOCSITE-30672 속도느릴때 selectedModelBar 높이값 오류 수정
            //         setTimeout(function(){
            //             if(self.isMobile() && self.$selectedModelBar.parent().height() < 100) {
            //                 self.$selectedModelBar.parent().removeAttr('style');
            //             }
            //         }, 100);
                    
            //     }
            // });


            // self.$modelSlider.on('carouselinit carouselreInit carouselafterchange carouselresize', function() {
            //     self._resetFlexibleBox();
            // });
            // self.$modelSlider.on('carouselreinit', function(e, module) {
            //     var startPage = parseInt((self.page - 1) / 10) * 10 + 1;
                
            //     if (startPage != 1 && (self.page % 10 == 1)) {
            //         self._toggleArrow(module.$prevArrow, true);
            //         module.$prevArrow.addClass('btn-prev');
            //     }
            // });
            // self.$modelSlider.on('carouselbeforechange', function(e, module, before, after) {
            //     var page = after - before;
            
            //     self.page += page;
            // });
            // self.$modelSlider.on('carouselafterchange', function(e, module, after) {
            //     var startPage = parseInt((self.page - 1) / 10) * 10 + 1; 
            //     var endPage = startPage + 10 - 1;

            //     if (startPage != 1 && (self.page % 10 == 1)) {
            //         self._toggleArrow(module.$prevArrow, true);
            //         module.$prevArrow.addClass('btn-prev');
            //     } else {
            //         module.$prevArrow.removeClass('btn-prev');
            //     }

            //     if (after == 9 && (endPage != self.totalCount)) {
            //         self._toggleArrow(module.$nextArrow, true);
            //         module.$nextArrow.addClass('btn-next');
            //     } else {
            //         module.$nextArrow.removeClass('btn-next');
            //     }
            // });
            // self.$modelSlider.on('click', '.btn-prev', function() {
            //     self.param = $.extend(self.param, {
            //         page: self.page - 1
            //     });
                
            //     self._requestTopicData();
            // });
            // self.$modelSlider.on('click', '.btn-next', function() {
            //     self.param = $.extend(self.param, {
            //         page: self.page + 1
            //     });
                
            //     self._requestTopicData();
            // });


            // 모델명 검색 - 스스로해결
            self.$modelInput.on('input', function() {
                var $this = $(this),
                    value = $this.val().toUpperCase();

                // BTOCSITE-9665 고객지원 모델명 검색창 한글 입력 허용
                // var regex = /[^a-zA-Z0-9.\-]/g;
                var regex =/[^가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9.\-]/g;

                if (regex.test(value)) {
                    $this.val(value.replace(regex,""));
                    return;
                }


                value = $this.val().toUpperCase();
                    
                if (value.length > 1 || !value) {
                    self.param = $.extend(self.param, {
                        keyword: value,
                        page: 1
                    });

                    self.$modelError.hide();
                } else {
                    self.$modelError.show();
                }
            });

            // 모델명 검색 - 스스로해결
            self.$modelInput.on('keyup', function(e) {
                if (e.keyCode == 13) {
                    e.preventDefault();
                    self.$modelButton.trigger('click');
                }
            });

            // 모델명 검색 - 스스로해결
            self.$modelButton.on('click', function() {
                var value = self.$modelInput.val().toUpperCase();

                if (value.length > 1 || !value) {
                    self.param = $.extend(self.param, {
                        keyword: value,
                        page: 1
                    });

                    // self._requestTopicData();
                    // self.$modelError.hide();

                } else {
                    self.$modelError.show();
                }
            });

            // 모델명 선택 - 스스로해결
            self.$modelBox.on('click', '.search-layer .autocomplete-box a', function(e) {                
                e.preventDefault();

                var $this = $(this),
                    data = $this.data();

                self.param = $.extend(self.param, {
                    category: data.category,
                    subCategory: data.subCategory,
                    categoryNm: data.categoryNm,
                    subCategoryNm: data.subCategoryNm,
                    modelCode: data.modelCode,
                    productCode: data.productCode,
                    salesModelCode:	data.salesModelCode
                });
                
                $('#category').val(data.category);
                $('#categoryNm').val(data.categoryNm);
                $('#subCategory').val(data.subCategory);
                $('#subCategoryNm').val(data.subCategoryNm);
                $('#modelCode').val(data.modelCode);
                $('#productCode').val(data.productCode);
                $('#salesModelCode').val(data.salesModelCode);

                /* self.updateSummary({
                    product: [data.categoryNm, data.subCategoryNm, data.salesModelCode]
                });
                */
                self.updateSummary({
                        product: [data.categoryNm, data.subCategoryNm, data.modelCode]
                });

                // self.$tabWrap.addClass('dpn');
                // self.$selectedModelBar.show(); // 플로팅바 노출
                // self.$stepArea.show(); // 정보 입력창 노출
                // self.$prodSearchWrap.hide();

                self.completeSummary(self.param);

                // self._requestTopicData();
            });
            
            // 모델명 선택 - 카테고리 선택 - 스스로해결
            self.$modelBox.find('#categorySelect').on('change', function(e, subValue) {
                var $this = $(this);

                // if ($this.val() === "all") {
                //     $('#prdGrp02').hide();
                // }

                var param = {
                    categorySelect: $this.val()
                };
                var value = typeof subValue === 'string' ? subValue : '';

                $("#category").val(param.categorySelect);
                $("#categoryNm").val($this.find('option:selected').text());

                lgkorUI.showLoading();
                
                lgkorUI.requestAjaxData(self.subCategoryUrl, param, function(result) {
                    
                    var $subCategory = self.$modelBox.find('#subCategorySelect');
                    var data = result.data.optionData || result.data,
                        arr = data instanceof Array ? data : [],
                        html = '';

                    if (arr.length) {
                        html += '<option value="all" data-category-name="all" class="placeholder">제품명 선택</option>'
                        arr.forEach(function(item) {
                            html += vcui.template('<option value={{value}}>{{name}}</option>', item);
                        });
            
                        $subCategory
                            .html(html)
                            .val(value)
                            .prop('disabled', false);
                    }

                    $subCategory.vcSelectbox('update');
                    
                    self.$modelPopup.data('category', $this.val());
                    self.$modelPopup.data('subCategory', value);
                    
                    self.param = $.extend(self.param, {
                        category: $this.val(),
                        categoryNm: $this.find('option:selected').text(),
                        subCategory: value,
                        subCategoryNm: $subCategory.find('option[value="'+value+'"]').text(),
                        page: 1
                    });

                    if (typeof subValue !== 'string') {
                        self.updateSummary({
                            product: [$this.find('option:selected').text(), $subCategory.find('option[value="'+value+'"]').text()]
                        });
                    }
                    // $('#prdGrp02').find('.ui-selectbox-wrap').addClass('on'); // 서브 카테고리 자동 열림
                    // $('#prdGrp02').find('.ui-selectbox-list').show();

                    $('#prdGrp02').show();
                    self.$modelBox.find('#subCategorySelect').trigger('selectboxopen'); 

                    // self.completeSummary(self.param);

                    lgkorUI.hideLoading();
                });
                
            });

            // 모델명 선택 - 서브 카테고리 선택 - 스스로해결
            self.$modelBox.find('#subCategorySelect').on('change', function() {
                var $this = $(this),
                    $category = self.$modelBox.find('#categorySelect');
                    
                if ($this.val() === "all") {
                    return;
                }

                if (self.$el.hasClass('service-engineer') && ($this.val() == 'CT50019259' || $this.val() == 'CT50019244') && $('#hiDownTimeFlag').val() == 'Y') {                    
                    lgkorUI.alert('(자세한 내용은 공지사항을 확인하시기 바랍니다.)<br>점검시간 : '+ $('#hirunDownStartTime').val() +' ~ '+ $('#hirunDownEndTime').val(),{
                        title: '시스템 점검 중으로, <br>\'시스템에어컨\', \'업소용 스탠드형\'<br>신청 및 조회가 불가합니다.'
                    });
                    return;
                }

                self.$modelPopup.data('category', $category.val());
                self.$modelPopup.data('subCategory', $this.val());

                self.param = $.extend(self.param, {
                    category: $category.val(),
                    subCategory: $this.val(),
                    categoryNm: $category.find('option:selected').text(),
                    subCategoryNm: $this.find('option:selected').text()
                });

                $("#subCategory").val(self.param.subCategory);
                $("#subCategoryNm").val($this.find('option:selected').text());
                $("#modelCode").val("");      //jslee   카테고리 선텍시 모델코드 초기화
                
                self.updateSummary({
                    product: [$category.find('option:selected').text(), $this.find('option:selected').text()]
                });

                // self.$selectedModelBar.show(); // 플로팅바 노출
                self.$stepArea.show(); // 정보 입력창 노출
                // self.$prodSearchWrap.hide();
                
                self._requestSearchEngine();
                //self._requestTopicData();

                // self.completeSummary(self.param);
            });
        },
        _setMyModel: function _setMyModel() {
            var self = this;

            if (!self.$myModelSlider.find('ul').children().length) {
                self.$tabWrap.find('a').eq(1).click();
                //self.$tabWrap.addClass('dpn');
                return;
            }

            self.$myModelSlider.find('a').each(function() {
                var modelCode = $(this).data('modelCode');
                myModel.push(modelCode);
            });

            self.$myModelWrap.find('.btn-toggle').attr('aria-expanded', true);

            // self.$myModelSlider.vcCarousel({

            //     slidesToScroll: 3,
            //     slidesToShow: 3,
            //     infinite: false,
            //     cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
            //     speed: 150,
            //     touchThreshold: 100,
            //     responsive: [
            //         {
            //             breakpoint: 10000,
            //             settings: {
            //                 slidesToScroll: 3,
            //                 slidesToShow: 3,
            //                 infinite: false
            //             }
            //         },
            //         {
            //             breakpoint: 1024,
            //             settings: {
            //                 slidesToScroll: 2,
            //                 slidesToShow: 2,
            //                 infinite: false
            //             }
            //         },
            //         {
            //             breakpoint: 768,
            //             settings: {
            //                 arrows: false,
            //                 variableWidth: true,
            //                 slidesToScroll: 1,
            //                 slidesToShow: 1,
            //                 infinite: false
            //             }
            //         }
            //     ]
            // });
            // 보유제품 선택 시
            self.$myModelSlider.on('click', 'a.slide-box', function(e) {
                e.preventDefault();

                var $this = $(this),
                    data = $this.data();
            

                // BTOCSITE-31495 H&A 제품 사용 설명서 호출 시 유입 경로 파악을 위한 UTM 정보 삽입 요청
                if(!!$('#salesDateForUTM')){
                    $('#salesDateForUTM').val(vcui.date.format(vcui.date.parse(data.salesDt), 'yyyy-MM-dd'));
                }
                
                if ($this.hasClass('disabled')) {
                    $(window).trigger("toastshow", "예약 가능한 제품이 아닙니다.");
                // BTOCSITE-7947
                } else if ($this.hasClass('regist-type')) {
                	var href = $(this).attr('href');
                	location.href = href;
                } else {
                	$('#accessType').val("002"); //보유제품
                    self.complete(data);
                }
            });

            self.$myModelWrap.find('.btn-toggle').on('click', function() {
                var $this = $(this),
                    $toggleBox = $this.closest('.box');

                if ($toggleBox.hasClass('open')) {
                    $toggleBox.removeClass('open');
                    $this.attr('aria-expanded', false);
                    $this.html('보유제품 펼치기');
                    self.$myModelSlider.stop().slideUp();
                } else {
                    $toggleBox.addClass('open');
                    $this.attr('aria-expanded', true);
                    $this.html('보유제품 접기');
                    self.$myModelSlider.stop().slideDown();
                }
            });
        },
        _resetFlexibleBox: function _resetFlexibleBox() {
            var self = this;
            var maxheight = 0;

            self.$modelSlider.find('.ui_carousel_current').each(function(idx, item){
                $(item).find('.slide-conts').each(function(cdx, child){
                    var flexiblebox = $(child).find('.info');
                    maxheight = Math.max(maxheight, flexiblebox.outerHeight(true));
                });
            });

            self.$modelSlider.find('.slide-conts').height(maxheight);
        },
        _toggleArrow: function _toggleArrow($arrow, flag) {
            $arrow[flag ? 'removeClass' : 'addClass']('disabled')
                        .prop('disabled', !flag)
                        .attr('aria-disabled', (!flag).toString());
        },
        _requestSearchEngine: function _requestSearchEngine() {
            var self = this,
                url = self.$prodSearchWrap.data('autocompleteUrl'); // BTOCSITE-62364 모델번호, 제조번호 입력

            //selectModelSearchEngine.lgajax
            lgkorUI.showLoading();
            lgkorUI.requestAjaxData(url, self.param, function(result) {
                var resultData = result.data;
                
                if(resultData.listData.length > 0) {
                    $('#productCode').val(resultData.listData[0].productCode);
                    self.param.productCode = resultData.listData[0].productCode;

                    self.completeSummary(self.param);  //productCode 받기
                }
                lgkorUI.hideLoading();
            });
        },
        _setBuyingDate: function(warrentyYear){
            //BTOCSITE-61349 고객지원 > 출장예약 > 구매일 정보 간소화
            var tmpl = '';
    
            if(warrentyYear == 2){ //warrentyYear 2년이내, value : 0,2,3,4
                tmpl = '<li><span class="rdo-wrap"><input type="radio" name="buyingdate" id="buyingdate01" value="0"><label for="buyingdate01">1개월 이내</label></span></li>' +
                    '<li><span class="rdo-wrap"><input type="radio" name="buyingdate" id="buyingdate02" value="2"><label for="buyingdate02">2년 이내</label></span></li>' +
                    '<li><span class="rdo-wrap"><input type="radio" name="buyingdate" id="buyingdate03" value="3"><label for="buyingdate03">2년 이상</label></span></li>' +
                    '<li><span class="rdo-wrap"><input type="radio" name="buyingdate" id="buyingdate04" value="4"><label for="buyingdate04">기억 안남</label></span></li>'
                
            }else{ //warrentyYear 1년이내, value : 0,1,3,4
                
                tmpl = '<li><span class="rdo-wrap"><input type="radio" name="buyingdate" id="buyingdate01" value="0"><label for="buyingdate01">1개월 이내</label></span></li>' +
                    '<li><span class="rdo-wrap"><input type="radio" name="buyingdate" id="buyingdate02" value="1"><label for="buyingdate02">1년 이내</label></span></li>' +
                    '<li><span class="rdo-wrap"><input type="radio" name="buyingdate" id="buyingdate03" value="3"><label for="buyingdate03">1년 이상</label></span></li>' +
                    '<li><span class="rdo-wrap"><input type="radio" name="buyingdate" id="buyingdate04" value="4"><label for="buyingdate04">기억 안남</label></span></li>'
            }

            $('#salesDt ul').empty().html(tmpl);
        },
        getSearchModeOCR: function(modelCode){
            //BTOCSITE-91187 고객지원 > 서비스 예약 > 모델명, 제조번호 입력 시 OCR 제공
            var self = this;
            var autoUrl = $('.prod-selected-box').data('autocompleteUrl');
            var param = {
                keyword: modelCode,
                pageCode: $('#pageCode').val(),
                serviceType: $('#serviceType').val(),
                page: 1
            }
            lgkorUI.showLoading();
            lgkorUI.requestAjaxData(autoUrl, param, function(result) {
                var _data = result.data;

                if(result.status == 'success'){
                    if (_data.listData.length > 0) {  

                        _data.listData.forEach(function(item, index) {
                            if(item.modelCode == modelCode){

                                self.param = $.extend(self.param, {
                                    category: item.category,
                                    subCategory: item.subCategory,
                                    categoryNm: item.categoryNm,
                                    subCategoryNm: item.subCategoryNm,
                                    modelCode: item.modelCode,
                                    productCode: item.productCode,
                                    salesModelCode:	item.salesModelCode
                                });
                                
                                $('#category').val(item.category);
                                $('#categoryNm').val(item.categoryNm);
                                $('#subCategory').val(item.subCategory);
                                $('#subCategoryNm').val(item.subCategoryNm);
                                $('#modelCode').val(item.modelCode);
                                $('#productCode').val(item.productCode);
                                $('#salesModelCode').val(item.salesModelCode);
                
                                self.updateSummary({
                                    product: [item.categoryNm, item.subCategoryNm, item.modelCode]
                                });
                
                                self.completeSummary(self.param);
                            }
                        });

                    }else{
                        self.completeSummary({
                            modelCode: modelCode
                        });
                    }
                }
                lgkorUI.hideLoading();
            });
        },
        setModelCodeAsParam: function setModelCodeAsParam(){
            var self = this;

            //BTOCSITE-95465 출장서비스예약 Scene 내 제품정보 식별 로직 개선 (제조번호 추가)
            if($('#serviceType').val() != 'A'){
                return;   
            }
            var _serialNumber = lgkorUI.getParameterByName('serialNumber');
            var _modelCode = lgkorUI.getParameterByName('mktModelCd');
            //모델명, 시리얼번호 넘어오는 경우 탭 이동
            if(_modelCode|| _serialNumber){
                self.$tabWrap.vcTab('select', 1);
            }
            //모델명, 시리얼번호 넘어오는 경우 겂 셋팅
            if(_modelCode){
                self.$modelSearchBox.find('[id="search"]').vcInputClearButton('updateVal', _modelCode);
                self.completeSummary({
                    modelCode: _modelCode
                });
            }
            if(_serialNumber){
                self.$modelSearchBox.find('[id="sn"]').val(_serialNumber);
            }

        },
        _requestTopicData: function _requestTopicData() {
            var self = this;
            lgkorUI.showLoading();
            lgkorUI.requestAjaxData(self.resultUrl, self.param, function(result) {
                var resultData = result.data;
                // 에어컨 > 시스템 에어컨 OR 창문형/이동식 선택 시
                // BTOCSITE-3200 출장서비스 예약 > 추가정보_건물유형 수정 등 

                //출장 서비스 예약
                if(self.$cont.hasClass('service-engineer')){
                    //BTOCSITE-61349 고객지원 > 출장예약 > 구매일 정보 간소화
                    if(!!resultData.warrentyYear){
                        self._setBuyingDate(resultData.warrentyYear);
                    }
                }

                //상담 예약/문의
                if(self.$cont.hasClass('online-service')){
                    if (!!resultData.warrantyText && resultData.warrantValue.toString()) {
						$('#buyingdate').val(resultData.warrantValue);
						self.$salesDtWrap.find('.text').html(resultData.warrantyText);
						self.$salesDtWrap.find('.text').show();
						self.$salesDtWrap.find('.rdo-list-wrap').hide();
                        self.$saleInfoBox.find('.tit-wrap .tit').text('제품 구매 정보를 확인해 주세요');
                    }else{
                        self.$salesDtWrap.find('.text').hide();
                        self.$salesDtWrap.find('.rdo-list-wrap').show();
                    }

                }
                
                //출장예약 일때
                if(self.isEngineerReservation){
                    // if (self.param.category == 'CT50019183') {
                    //     //self.$saleInfoBox.show(); //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응
                    //     if (self.param.subCategory == "CT50019259"){
                    //         self.$saleInfoBox.show();
                    //         self.$fanBox.show();
                    //         // BTOCSITE-15707 출정서비스 예약, 전제품 대상 사용처 구분 추가 및 SMILE 연동 수정 등
                    //         // BTOCSITE-31948 홈서비스 통합 출장 서비스 주체 변화 (23/3/1 시행)
                    //         // self.$bdTypeBox.show().data('current-product-code', 'CRB');
                    //     } else if (self.param.subCategory == "CT50019244") {
                    //         self.$saleInfoBox.show();
                    //         self.$fanBox.show();
                    //         // self.$bdTypeBox.show(); 
                    //     } else if (self.param.subCategory != "CT50019229") {
                    //         self.$saleInfoBox.show();
                    //         self.$fanBox.show();
                    //         // BTOCSITE-15707 출정서비스 예약, 전제품 대상 사용처 구분 추가 및 SMILE 연동 수정 등
                    //         // self.$bdTypeBox.hide().data('current-product-code', ''); 
                    //     }
                    // }

                    //렌탈여부 추가 (서충원, 230616)
                    // self.$rentalYnBox.show();	
    
                    // BTOCSITE-15707 출정서비스 예약, 전제품 대상 사용처 구분 추가 및 SMILE 연동 수정 등 
                    // BTOCSITE-31948 홈서비스 통합 출장 서비스 주체 변화 (23/3/1 시행)
                    // self.$bdTypeBox.show().data('current-product-code', '');
    
                    // 드럼 세탁기 OR 의류 건조기 선택 시
                    // if (self.param.subCategory == "CT50019309" || self.param.subCategory == "CT50019275") {
                    //     self.$saleInfoBox.show(); //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응
                    //     self.$installTypeBox.show();
                    // } else {
                    //     self.$installTypeBox.hide();
                    // }
                    
                    // TV/프로젝터 > 올레드, 울트라HD, LED/LCD, PDP 선택 시
                    // if (self.param.subCategory == "CT50019082" || self.param.subCategory == "CT50019037" || self.param.subCategory == "CT50019052" || self.param.subCategory == "CT50019067" || self.param.subCategory == "CT50109019" || self.param.subCategory == "CT50109023") {
                    //     self.$saleInfoBox.show(); //BTOCSITE-69400 고객지원 > 출장예약 > 구매정보 입력 단계 수정 및 스타일러 도어 대응
                    //     self.$tvPositionBox.show();
                    // } else {
                    //     self.$tvPositionBox.hide();
                    // }
    
                    if($(".agree-wrap")) {
                        if((self.param.subCategory == 'CT50019259' || self.param.subCategory == 'CT50019244')) { // 하이런일 때,
                            $("#marketingUseAgree").show();
                            if(!isLogin) {
                                $('.agree-all-chk').show();
                            } else {
                                $('.agree-all-chk').hide();
                            }
                        }
                    }
                }

                self.setTopicList(resultData);

                lgkorUI.hideLoading();
            });
        },
        setTopicList: function(data) {
            var self = this;
            var html;
            var success = (data.topicList instanceof Array && data.topicList.length) ? true : false;
            if (success) {
                html = vcui.template(topicTmpl, data);
                self.$topicList.html(html);
            }else{
                self.$topicList.empty();
            }
        },
        isMobile: function(){
            return window.innerWidth < 768;
        }, 
        updateSummary: function updateSummary(summary) {
            var self = this;
            var summary = summary || self.options.summary;
            
            if (summary.product) {
                summary.product.forEach(function(item, index) {
                    var temp = {};
                    temp.name = item;
                    summary.product[index] = temp;
                });
            }
            //모델코드를 통한 보유제품 구분 추가
            var len = $('.my-product-wrap li a').length;
            if(len > 0 && $('input#modelCode').val() != ''){
                var curruntModelCode = $('input#modelCode').val()
                for(var i=0; i < len; i++){
                    if (curruntModelCode == $('.my-product-wrap li a').eq(i).data('modelCode')){
                        summary.isMyProduct="Y";
                        if(self.$tabWrap.vcTab("getSelectIdx").toString() == '0'){
                            $('input#serialNumber').val($('.my-product-wrap li a').eq(i).data('serialNumber'));
                        }
                        break;
                    }
                }
            }
            
            self.$selectedModelBar.html(vcui.template(selectedBarTmpl, summary));
        },
        focus: function focus($target, callback) {
            var self = this,
                targetTop = $target.offset().top; // BTOCSITE-20543 고객지원 메뉴 - 포커스 이동 위치 수정
                
            self.headerHeight = self.isMobile() ? $('.header-wrap').height() : 0; // BTOCSITE-20543 고객지원 메뉴 - 포커스 이동 위치 수정
            var scrollTop = self.isMobile ? (targetTop - self.headerHeight) : targetTop; // BTOCSITE-20543 고객지원 메뉴 - 포커스 이동 위치 수정
            $('html, body').stop().animate({
                scrollTop: scrollTop // BTOCSITE-20543 고객지원 메뉴 - 포커스 이동 위치 수정
            }, function() {
                callback && callback();
            });
        },
        next: function next($target) {
            var self = this,
                opt = self.options;

            var $nextStep = $target ? $target : self.$stepModel.next();

            $nextStep.siblings('.'+ opt.stepClass).removeClass(opt.stepActiveClass);
            $nextStep.addClass(opt.stepActiveClass);
        },
        reset: function reset() {
            var self = this;
            var defaults = $.extend(true, {}, self.defaults);
            // var modelStepFirst = self.$stepBox.eq(0).attr('id') == 'stepModel' ? true : false;

            self.$tabWrap.show(); 
            // self.$stepBox.show();

            self.$stepArea.hide();
            self.$selectedModelBar.hide();

            self.$prodSearchWrap.show();

            self.hasModel = false;
            self.page = defaults.page;
            self.totalCount = defaults.totalCount;
            self.model = $.extend(true, {}, defaults.model, {
                pageCode: self.$el.find('#pageCode').val(),
                serviceType: self.$el.find('#serviceType').val(),
                salesModelCode: self.$el.find('#salesModelCode').val()
            });
            self.param = $.extend(true, {}, defaults.model, {
                keyword: ''
            });

            self.$el.find('#category').val('');
            self.$el.find('#categoryNm').val('');
            self.$el.find('#subCategory').val('');
            self.$el.find('#subCategoryNm').val('');
            self.$el.find('#modelCode').val('');
            self.$el.find('#productCode').val('');
            self.$el.find('#salesModelCode').val('');
            self.$el.find('#isMyProduct').val('N');
            self.$el.find('.agree-wrap input[type=checkbox]').prop('checked', false);

            // $('#prdGrp02').hide();
            self.$prodSearchWrap.find('.search-error').hide();
            // self.$keywordInput.val('');
            //self.$categoryBox.find('.box').removeClass('on off');
            //self.$categoryBox.addClass(defaults.stepActiveClass);
            //self.$modelBox.removeClass(defaults.stepActiveClass);
            //self.$modelBox.find('.keyword-search').show();
            self.$modelSearchInput.val('');
            //self.$modelSlider.find('.slide-track').empty();
            self.$modelSelectBox.find('#categorySelect').find('option:first-child').prop('selected', true);
            self.$modelSelectBox.find('#categorySelect').vcSelectbox('update');
            self.$modelSelectBox.find('#subCategorySelect').find('option:not(:first-child)').remove();
            self.$modelSelectBox.find('#subCategorySelect').vcSelectbox('update');
            
            // self.$selectedModelBar.vcSticky('destroy');
            
            self.$el.trigger('reset');

            self.updateSummary();
            // self.next(self.$stepBox.eq(0));

            // if (modelStepFirst) {
            //     self.$myModelWrap.show();
            //     self.$myModelSlider.vcCarousel('resize');
            //     self.focus(self.$selectedModelBar);
            // } else {
                //self.$selectedModelBar.hide();
                self.focus(self.$stepBox.eq(0));
            // }

            if (!self.$myModelSlider.find('ul').children().length) {
                self.$tabWrap.find('a').eq(1).click();
                //self.$tabWrap.addClass('dpn');
            }
        },
        completeSummary: function completeSummary(data) {
            var data = $.extend(self.model, data || {});
            vcui.PubSub.trigger('completeSummary',[data]);
        },
        complete: function complete(data) {
            var self = this;
            var data = $.extend(self.model, data || {});

            if (data) {
                for (var key in data) {
                    if (self.$el.find('#'+key).length) {
                        self.$el.find('#'+key).val(data[key]);
                    }
                }
                
                if (myModel.indexOf(data.modelCode) != -1) self.$el.find('#isMyProduct').val('Y');
                if (data.modelCode) lgkorUI.recentlySearch.addCookie(data.modelCode);
            }
                
            self.$el.trigger('complete', [data]);

        },
    });

    return SearchModelNew;
});